export type BrowserFeature =
  | "WebRTC"
  | "WebSocket"
  | "WebCrypto"
  | "PerformanceClock"
  | "TextEncoding";

export class BrowserFeatureError extends Error {
  readonly feature: BrowserFeature;

  constructor(feature: BrowserFeature, detail?: string) {
    super(detail ? `${feature} is unavailable: ${detail}` : `${feature} is unavailable`);
    this.name = "BrowserFeatureError";
    this.feature = feature;
  }
}

export class MatchTransportError extends Error {
  readonly code:
    | "invalid-state"
    | "signaling"
    | "peer-connection"
    | "channel-closed"
    | "protocol"
    | "handshake"
    | "clock"
    | "seed";
  readonly recoverable: boolean;

  constructor(
    code: MatchTransportError["code"],
    message: string,
    options: { readonly recoverable?: boolean; readonly cause?: unknown } = {},
  ) {
    super(message, options.cause === undefined ? undefined : { cause: options.cause });
    this.name = "MatchTransportError";
    this.code = code;
    this.recoverable = options.recoverable ?? false;
  }
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
